import { StyledWidgetFrame } from './WidgetFrame.styled';

const WidgetFrame = ({ children, height = '100%' }) => {
  return (
    <StyledWidgetFrame $height={height}>
      <div className='scroller'>
        {children}
        <div className='screen-corner screen-corner-tl'/>
        <div className='screen-corner screen-corner-tr'/>
        <div className='screen-corner screen-corner-bl'/>
        <div className='screen-corner screen-corner-br'/>
      </div>
    </StyledWidgetFrame>
  );
};

export default WidgetFrame;
